module.exports = __webpack_public_path__ + "img/D3.5f8b91cf.png";